import React, { useEffect, useState } from "react";
import { Tab, Tabs, Card, Button, Form, Table, Spinner, Badge } from "react-bootstrap";
import useIspettori from "../../hooks/useIspettori";
import useCorsi from "../../hooks/useCorsi";
import CustomModal from "../../components/CustomModal/CustomModal";
import UtilityService from "../../services/UtillityServices/UtilityService";

const AZIONI_LABEL = {
  accesso_area_ispezione: "Accesso area ispezione",
  elenco_corsisti: "Elenco corsisti",
  visualizza_anagrafica: "Visualizza anagrafica",
  visualizza_percorso_formativo: "Percorso formativo",
  download_report_attivita: "Download report",
  admin_crea_ispettore: "Creazione ispettore",
  admin_assegna_corsi: "Assegnazione corsi",
  admin_rimuovi_corso: "Rimozione corso",
};

const GestioneIspezioniPage = () => {
  const {
    loadingIspettori,
    findEnti,
    createEnte,
    updateEnte,
    deleteEnte,
    findIspettori,
    createIspettore,
    updateIspettore,
    assegnaCorsi,
    rimuoviCorso,
    findCorsiByIspettore,
    findAccessLog,
    indexEnti,
  } = useIspettori();
  const { getAllCorsi } = useCorsi();

  const [enti, setEnti] = useState([]);
  const [ispettori, setIspettori] = useState([]);
  const [logRows, setLogRows] = useState([]);
  const [allCorsi, setAllCorsi] = useState([]);
  const [entiSelect, setEntiSelect] = useState([]);

  const [enteForm, setEnteForm] = useState({ denominazione: "", codice: "", note: "", attivo: 1 });
  const [editEnte, setEditEnte] = useState(null);
  const [ispettoreForm, setIspettoreForm] = useState({
    username: "", nome: "", cognome: "", id_ente_ispettivo: "", telefono1: "",
  });
  const [editIspettore, setEditIspettore] = useState(null);
  const [assignForm, setAssignForm] = useState({ id_utente: "", id_ente_ispettivo: "", id_corsi: [] });
  const [assignedCorsi, setAssignedCorsi] = useState([]);
  const [logFilter, setLogFilter] = useState({ id_utente: "", data_da: "", data_a: "" });

  const [showEnteModal, setShowEnteModal] = useState(false);
  const [showIspModal, setShowIspModal] = useState(false);

  const loadEnti = async () => {
    const res = await findEnti({ filtri: {}, limite: 200, pagina: 1 });
    setEnti(Array.isArray(res) ? res : []);
  };

  const loadIspettori = async () => {
    const res = await findIspettori({ filtri: {}, limite: 200, pagina: 1 });
    setIspettori(Array.isArray(res) ? res : []);
  };

  const loadLog = async () => {
    const filtri = {};
    if (logFilter.id_utente) filtri.id_utente = logFilter.id_utente;
    if (logFilter.data_da) filtri.data_da = logFilter.data_da;
    if (logFilter.data_a) filtri.data_a = logFilter.data_a;
    const res = await findAccessLog({ filtri, limite: 100, pagina: 1 });
    setLogRows(Array.isArray(res) ? res : []);
  };

  useEffect(() => {
    loadEnti();
    loadIspettori();
    loadLog();
    indexEnti().then((r) => setEntiSelect(Array.isArray(r) ? r : []));
    getAllCorsi().then((r) => setAllCorsi(Array.isArray(r) ? r : []));
  }, []);

  const salvaEnte = async () => {
    if (UtilityService.validationForm(enteForm, ["denominazione"]).length > 0) return;
    if (editEnte) {
      await updateEnte({ ...enteForm, id_ente_ispettivo: editEnte.id_ente_ispettivo });
    } else {
      await createEnte(enteForm);
    }
    setShowEnteModal(false);
    setEditEnte(null);
    setEnteForm({ denominazione: "", codice: "", note: "", attivo: 1 });
    loadEnti();
    indexEnti().then((r) => setEntiSelect(Array.isArray(r) ? r : []));
  };

  const salvaIspettore = async () => {
    const req = editIspettore
      ? ["id_utente", "nome", "cognome", "id_ente_ispettivo"]
      : ["username", "nome", "cognome", "id_ente_ispettivo"];
    if (UtilityService.validationForm(editIspettore || ispettoreForm, req).length > 0) return;
    if (editIspettore) {
      await updateIspettore(editIspettore);
    } else {
      await createIspettore(ispettoreForm);
    }
    setShowIspModal(false);
    setEditIspettore(null);
    setIspettoreForm({ username: "", nome: "", cognome: "", id_ente_ispettivo: "", telefono1: "" });
    loadIspettori();
  };

  const onSelectIspettoreAssign = async (id_utente) => {
    setAssignForm((f) => ({ ...f, id_utente }));
    const corsi = await findCorsiByIspettore(id_utente);
    setAssignedCorsi(Array.isArray(corsi) ? corsi : []);
    const isp = ispettori.find((i) => String(i.id_utente) === String(id_utente));
    if (isp?.id_ente_ispettivo) {
      setAssignForm((f) => ({ ...f, id_utente, id_ente_ispettivo: isp.id_ente_ispettivo }));
    }
  };

  const toggleCorsoAssign = (id_corso) => {
    const key = String(id_corso);
    setAssignForm((f) => {
      const set = new Set(f.id_corsi.map(String));
      if (set.has(key)) set.delete(key);
      else set.add(key);
      return { ...f, id_corsi: [...set] };
    });
  };

  const isCorsoAssignSelected = (id_corso) =>
    assignForm.id_corsi.map(String).includes(String(id_corso));

  const submitAssign = async () => {
    if (!assignForm.id_utente || !assignForm.id_ente_ispettivo || assignForm.id_corsi.length === 0) return;
    await assegnaCorsi({
      ...assignForm,
      id_corsi: assignForm.id_corsi.map((id) => Number(id)),
    });
    onSelectIspettoreAssign(assignForm.id_utente);
    setAssignForm((f) => ({ ...f, id_corsi: [] }));
    loadLog();
  };

  return (
    <div>
      <h2 className="mb-1">Gestione ispezioni ICMQ</h2>
      <p className="text-muted mb-4">
        Censisci enti certificatori, utenti ispettori, assegna i corsi da verificare e monitora gli accessi.
      </p>

      <Tabs defaultActiveKey="enti" className="mb-3">
        <Tab eventKey="enti" title="Enti ispettivi">
          <div className="d-flex justify-content-end mb-3">
            <Button onClick={() => { setEditEnte(null); setEnteForm({ denominazione: "", codice: "", note: "", attivo: 1 }); setShowEnteModal(true); }}>
              <i className="bi bi-plus-lg me-1" /> Nuovo ente
            </Button>
          </div>
          {loadingIspettori.enti ? <Spinner /> : (
            <Table responsive hover className="bg-white shadow-sm">
              <thead><tr><th>Denominazione</th><th>Codice</th><th>Stato</th><th></th></tr></thead>
              <tbody>
                {enti.map((e) => (
                  <tr key={e.id_ente_ispettivo}>
                    <td>{e.denominazione}</td>
                    <td>{e.codice || "—"}</td>
                    <td><Badge bg={e.attivo ? "success" : "secondary"}>{e.attivo ? "Attivo" : "Disattivo"}</Badge></td>
                    <td className="text-end">
                      <Button size="sm" variant="outline-primary" className="me-1" onClick={() => { setEditEnte(e); setEnteForm({ ...e }); setShowEnteModal(true); }}>Modifica</Button>
                      <Button size="sm" variant="outline-danger" onClick={async () => { await deleteEnte(e.id_ente_ispettivo); loadEnti(); }}>Elimina</Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Tab>

        <Tab eventKey="ispettori" title="Ispettori">
          <div className="d-flex justify-content-end mb-3">
            <Button onClick={() => { setEditIspettore(null); setShowIspModal(true); }}>
              <i className="bi bi-person-plus me-1" /> Nuovo ispettore
            </Button>
          </div>
          {loadingIspettori.ispettori ? <Spinner /> : (
            <Table responsive hover className="bg-white shadow-sm">
              <thead><tr><th>Nome</th><th>Email</th><th>Ente</th><th>Corsi</th><th>Stato</th><th></th></tr></thead>
              <tbody>
                {ispettori.map((i) => (
                  <tr key={i.id_utente}>
                    <td>{i.nome} {i.cognome}</td>
                    <td>{i.username}</td>
                    <td>{i.ente_denominazione || "—"}</td>
                    <td>{i.num_corsi ?? 0}</td>
                    <td><Badge bg={Number(i.abilitato_web) === 1 ? "success" : "warning"}>{Number(i.abilitato_web) === 1 ? "Attivo" : "In attesa"}</Badge></td>
                    <td className="text-end">
                      <Button size="sm" variant="outline-primary" onClick={() => { setEditIspettore({ ...i }); setShowIspModal(true); }}>Modifica</Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Tab>

        <Tab eventKey="corsi" title="Assegnazione corsi">
          <Card className="border-0 shadow-sm mb-3">
            <Card.Body>
              <Form.Group className="mb-3">
                <Form.Label>Ispettore</Form.Label>
                <Form.Select value={assignForm.id_utente} onChange={(e) => onSelectIspettoreAssign(e.target.value)}>
                  <option value="">Seleziona ispettore…</option>
                  {ispettori.map((i) => (
                    <option key={i.id_utente} value={i.id_utente}>{i.cognome} {i.nome} ({i.username})</option>
                  ))}
                </Form.Select>
              </Form.Group>
              {assignForm.id_utente && (
                <>
                  <Form.Group className="mb-3">
                    <Form.Label>Ente ispettivo</Form.Label>
                    <Form.Select
                      value={assignForm.id_ente_ispettivo}
                      onChange={(e) => setAssignForm((f) => ({ ...f, id_ente_ispettivo: e.target.value }))}
                    >
                      <option value="">Seleziona ente…</option>
                      {entiSelect.map((e) => (
                        <option key={e.id_ente_ispettivo} value={e.id_ente_ispettivo}>{e.denominazione}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  <Form.Label>Corsi da assegnare</Form.Label>
                  <div className="border rounded p-2 mb-3" style={{ maxHeight: 220, overflowY: "auto" }}>
                    {allCorsi.map((c) => (
                      <Form.Check
                        key={c.id_corso}
                        type="checkbox"
                        id={`corso-assign-${c.id_corso}`}
                        name={`corso-assign-${c.id_corso}`}
                        label={c.denominazione}
                        checked={isCorsoAssignSelected(c.id_corso)}
                        onChange={() => toggleCorsoAssign(c.id_corso)}
                      />
                    ))}
                  </div>
                  <Button onClick={submitAssign} disabled={loadingIspettori.corsi || assignForm.id_corsi.length === 0}>
                    Assegna corsi selezionati
                  </Button>
                </>
              )}
            </Card.Body>
          </Card>
          {assignedCorsi.length > 0 && (
            <>
              <h5>Corsi già assegnati</h5>
              <Table responsive size="sm" className="bg-white shadow-sm">
                <thead><tr><th>Corso</th><th>Data assegnazione</th><th></th></tr></thead>
                <tbody>
                  {assignedCorsi.map((c) => (
                    <tr key={c.id}>
                      <td>{c.corso_titolo}</td>
                      <td>{UtilityService.formatDate?.(c.data_assegnazione) || c.data_assegnazione}</td>
                      <td>
                        <Button size="sm" variant="outline-danger" onClick={async () => {
                          await rimuoviCorso(assignForm.id_utente, c.id_corso);
                          onSelectIspettoreAssign(assignForm.id_utente);
                          loadLog();
                        }}>Rimuovi</Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </Tab>

        <Tab eventKey="log" title="Log accessi">
          <Card className="border-0 shadow-sm mb-3">
            <Card.Body className="row g-2 align-items-end">
              <div className="col-md-3">
                <Form.Label>Ispettore</Form.Label>
                <Form.Select value={logFilter.id_utente} onChange={(e) => setLogFilter((f) => ({ ...f, id_utente: e.target.value }))}>
                  <option value="">Tutti</option>
                  {ispettori.map((i) => (
                    <option key={i.id_utente} value={i.id_utente}>{i.cognome} {i.nome}</option>
                  ))}
                </Form.Select>
              </div>
              <div className="col-md-2">
                <Form.Label>Da</Form.Label>
                <Form.Control type="date" value={logFilter.data_da} onChange={(e) => setLogFilter((f) => ({ ...f, data_da: e.target.value }))} />
              </div>
              <div className="col-md-2">
                <Form.Label>A</Form.Label>
                <Form.Control type="date" value={logFilter.data_a} onChange={(e) => setLogFilter((f) => ({ ...f, data_a: e.target.value }))} />
              </div>
              <div className="col-md-2">
                <Button onClick={loadLog} disabled={loadingIspettori.log}>Filtra</Button>
              </div>
            </Card.Body>
          </Card>
          {loadingIspettori.log ? <Spinner /> : (
            <Table responsive hover className="bg-white shadow-sm small">
              <thead>
                <tr>
                  <th>Data/ora</th>
                  <th>Ispettore</th>
                  <th>Azione</th>
                  <th>Corso</th>
                  <th>Corsista</th>
                  <th>IP</th>
                </tr>
              </thead>
              <tbody>
                {logRows.map((r) => (
                  <tr key={r.id}>
                    <td>{new Date(r.data_accesso).toLocaleString("it-IT")}</td>
                    <td>{r.ispettore_nome}<br /><span className="text-muted">{r.ispettore_email}</span></td>
                    <td>{AZIONI_LABEL[r.azione] || r.azione}</td>
                    <td>{r.corso_titolo || "—"}</td>
                    <td>{r.corsista_nome || "—"}</td>
                    <td>{r.ip_address || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Tab>
      </Tabs>

      <CustomModal
        show={showEnteModal}
        onHide={() => setShowEnteModal(false)}
        headerText={editEnte ? "Modifica ente ispettivo" : "Nuovo ente ispettivo"}
        body={(
          <>
            <Form.Group className="mb-2">
              <Form.Label>Denominazione *</Form.Label>
              <Form.Control value={enteForm.denominazione} onChange={(e) => setEnteForm({ ...enteForm, denominazione: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Codice</Form.Label>
              <Form.Control value={enteForm.codice || ""} onChange={(e) => setEnteForm({ ...enteForm, codice: e.target.value })} placeholder="es. ICMQ" />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Note</Form.Label>
              <Form.Control as="textarea" rows={2} value={enteForm.note || ""} onChange={(e) => setEnteForm({ ...enteForm, note: e.target.value })} />
            </Form.Group>
            <Form.Check type="switch" label="Attivo" checked={!!Number(enteForm.attivo)} onChange={(e) => setEnteForm({ ...enteForm, attivo: e.target.checked ? 1 : 0 })} />
          </>
        )}
        onSave={salvaEnte}
        btnText="Salva"
        isLoading={loadingIspettori.enti}
      />

      <CustomModal
        show={showIspModal}
        onHide={() => setShowIspModal(false)}
        headerText={editIspettore ? "Modifica ispettore" : "Nuovo ispettore"}
        body={(
          <>
            {!editIspettore && (
              <Form.Group className="mb-2">
                <Form.Label>Email (username) *</Form.Label>
                <Form.Control type="email" value={ispettoreForm.username} onChange={(e) => setIspettoreForm({ ...ispettoreForm, username: e.target.value })} />
              </Form.Group>
            )}
            <Form.Group className="mb-2">
              <Form.Label>Nome *</Form.Label>
              <Form.Control value={(editIspettore || ispettoreForm).nome || ""} onChange={(e) => editIspettore ? setEditIspettore({ ...editIspettore, nome: e.target.value }) : setIspettoreForm({ ...ispettoreForm, nome: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Cognome *</Form.Label>
              <Form.Control value={(editIspettore || ispettoreForm).cognome || ""} onChange={(e) => editIspettore ? setEditIspettore({ ...editIspettore, cognome: e.target.value }) : setIspettoreForm({ ...ispettoreForm, cognome: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Ente ispettivo *</Form.Label>
              <Form.Select
                value={(editIspettore || ispettoreForm).id_ente_ispettivo || ""}
                onChange={(e) => editIspettore ? setEditIspettore({ ...editIspettore, id_ente_ispettivo: e.target.value }) : setIspettoreForm({ ...ispettoreForm, id_ente_ispettivo: e.target.value })}
              >
                <option value="">Seleziona…</option>
                {entiSelect.map((en) => (
                  <option key={en.id_ente_ispettivo} value={en.id_ente_ispettivo}>{en.denominazione}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Telefono</Form.Label>
              <Form.Control value={(editIspettore || ispettoreForm).telefono1 || ""} onChange={(e) => editIspettore ? setEditIspettore({ ...editIspettore, telefono1: e.target.value }) : setIspettoreForm({ ...ispettoreForm, telefono1: e.target.value })} />
            </Form.Group>
            {editIspettore && (
              <Form.Check type="switch" label="Account attivo" checked={!!Number(editIspettore.attivo)} onChange={(e) => setEditIspettore({ ...editIspettore, attivo: e.target.checked ? 1 : 0 })} />
            )}
          </>
        )}
        onSave={salvaIspettore}
        btnText="Salva"
        isLoading={loadingIspettori.ispettori}
      />
    </div>
  );
};

export default GestioneIspezioniPage;
